import { Box, Divider, useMediaQuery } from "@mui/material";
import { styled } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";

const CustomizedComponent = styled(Tabs)(({ theme }) => ({
  overflow: "hidden",
  minHeight: 48,
  WebkitOverflowScrolling: "touch", // Add iOS momentum scrolling.
  backgroundColor: theme.palette.commonground.main,
  color: theme.palette.commonground.contrastText,
  borderTopLeftRadius: "4px",
  borderTopRightRadius: "4px",
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    height: "6px",
    "& > div": {
      width: "100%",
      minHeight: "4px",
      backgroundColor: theme.palette.primary.main,
    },
  },
}));

const OmniDialogTabs = props => {
  const {
    children,
    tabIndex = 0,
    setTabIndex,
    scrollButtons = "auto",
    allowScrollButtonsMobile = true,
    variant = "scrollable",
    centered = true,
  } = props;

  const smallScreen = useMediaQuery(theme => theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        postion: "absolute",
        top: 64,
        minHeight: 72,
        overflow: "hidden",
        marginBottom: "-2px",
      }}
    >
      <Divider />
      <CustomizedComponent
        TabIndicatorProps={{ children: <div /> }}
        value={tabIndex}
        onChange={(event, newValue) => {
          setTabIndex(newValue);
        }}
        variant={smallScreen ? variant : "fullWidth"}
        scrollButtons={scrollButtons}
        allowScrollButtonsMobile={allowScrollButtonsMobile}
        centered={smallScreen ? centered : false}
      >
        {children}
      </CustomizedComponent>
      <Divider />
    </Box>
  );
};

export default OmniDialogTabs;
